/*
 * @Author: your name
 * @Date: 2020-12-07 18:02:15
 * @LastEditTime: 2020-12-09 20:37:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shopManagement/src/service/basic/exceptionApiList.js
 */
const r4SettleApiList = {
  getAccountList: '/pay/account/list', // 对账明细
  getAccountDetail: '/pay/account/list/detail', // 结算单明细
  exportData: '/pay/account/export',// 批量导出
  accountConfirm: '/pay/account/confirm',// 批量确认
  accountAppeal: '/pay/account/appeal',// 申诉
  originalOrder: '/pay/original-order',// 查看原单
  getRedBlueOffset: '/pay/check/supplier/support/redBlueOffset'// 判断供应商是否支持红蓝相抵
}
export default r4SettleApiList



// WEBPACK FOOTER //
// ./src/service/basic/r4SettleApiList.js